import { FC } from 'react';

interface IProps {
  downloadCsvFile?: () => void;
}

const ExportFilter: FC<IProps> = ({ downloadCsvFile }) => {
  return (
    <div className="action_filter_container">
      <div className="action_filter_columns" onClick={downloadCsvFile}>
        Export All
      </div>
    </div>
  );
};

export default ExportFilter;
